import React, { useState, useEffect } from "react";
import { getHospitals } from "../services/dashApiService";
import { Autocomplete } from "./common/Autocomplete";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

export const QuestionnaireHospitalPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState("");
	const [hospitals, setHospitals] = useState([]);
	const [hospitalsObj, setHospitalsObj] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getHospitals()
			.then((result) => {
				const hospitals = [];
				const hospitalsObj = {};
				for (const h of result.data.data) {
					hospitals.push({
						value: h.code,
						label: [`${h.name} (${h.city})`, h.parent],
					});
					hospitalsObj[h.code] = { label: [`${h.name} (${h.city})`, h.parent] };
				}

				setHospitals(hospitals);
				setHospitalsObj(hospitalsObj);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	}, []);

	useEffect(() => {
		setSelectedOption("");
	}, [def]);

	useEffect(() => {
		let opt;
		if (currentResponse && currentResponse.value) {
			opt = currentResponse.value;
		} else if (def.answer) {
			opt = def.answer;
			onAutoCompleteChange({ value: def.answer }, { action: "select-option" });
		} else {
			opt = "";
		}

		setSelectedOption(opt);
	}, [currentResponse, def, hospitals]);

	const onAutoCompleteInputChange = (value) => {
		// setSelectedOption(value);
	};

	const onAutoCompleteChange = (selection, actionMeta) => {
		let value;
		if (actionMeta.action === "select-option") {
			value = selection.value;
		} else if (actionMeta.action === "create-option") {
			value = selection.value;
		} else if (actionMeta.action === "clear") {
			value = "";
		} else {
			return;
		}

		const response = {};
		response.id = def.id;
		response.value = value;

		onRespond(response);
	};

	let value = isLoading ? "" : selectedOption || "";
	if (hospitalsObj && hospitalsObj[selectedOption]) {
		value = hospitalsObj[selectedOption];
	} else if (value.length > 0) {
		value = { value, label: value };
	}

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div className={"w-full pb-3 xs:pb-6 px-6 text-black text-center"}>
				<Autocomplete
					id="startMonth"
					options={hospitals}
					value={value}
					onChange={onAutoCompleteChange}
					onInputChange={onAutoCompleteInputChange}
					placeholder="Hospital - start typing for options"
					isClearable={true}
					isLoading={isLoading}
					allowCreate={def && def.params && def.params.allowCreate}
				/>
			</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
